import React, {Component} from 'react'
import _ from 'lodash';
import PropTypes from 'prop-types';

import {CCAppEventLogger, Constants, CCLGButton, strings, CCCounter, colors, CCFlag} from "./../../cc-imports";
import { withRouter } from 'react-router-dom';
// import './SimpleMatchDetails.css';
// import './SimpleMatchDetails_320.css';
import './../../styles/css/components/SimpleMatchDetails/simple-match-details.css'
import CCErrorBoundary from "../CCErrorBoundary/CCErrorBoundary";

const getFontColor=(active, ccMatch)=>{
    if(ccMatch.status==Constants.matchStatus.COMPLETED){
        return colors.theme2.font_color5;
    }
    else {
        return active? colors.theme2.font_color3:colors.theme2.font_color5;
    }
}


class InningsScore extends Component {

    constructor(){
        super()
        this._getOvers=this._getOvers.bind(this);
        this._getWickets=this._getWickets.bind(this);
        this._getRuns=this._getRuns.bind(this);
    }

    _getRuns(innings){
        if(innings) return innings.runs;
        else return 0;
    }

    _getWickets(innings){
        if(innings) return innings.wickets;
        else return 0;
    }

    _getOvers(innings){
        if(innings) return innings.overs;
        else return 0;
    }

    render() {
        const {inningses, ccMatch, active} = this.props;
        var filteredInnings = _.filter(inningses,(innings)=>{return innings.balls>0});
        var totalInnings = filteredInnings.length;
        if (totalInnings == 2) {
            return (
            <div  style={this.props.style}>
                <div className={'flex-container'} style={{flexDirection:'row', justifyContent:'center'}}>
                    <h2 className={'cc-score-txt_0_8'} style={{color:getFontColor(active, ccMatch)}}>{this._getRuns(inningses[0])}</h2>
                    <h3  className={'cc-score-txt_0_8'} style={{color:getFontColor(active, ccMatch)}}>&</h3>
                </div>
                <div className={'flex-container'}>
                    <h1 className={'cc-score-txt_1_0'} style={{color:getFontColor(active, ccMatch)}}>{this._getRuns(inningses[1]) + '/' + this._getWickets(inningses[1])}</h1>
                    <h3 className={'cc-score-txt_1_0'} style={{color:getFontColor(active, ccMatch)}}>{'(' + this._getOvers(inningses[1]) + ')'}</h3>
                </div>
            </div>)
        }
        else {
            return (
            <div className={'flex-container'}>
                <h1  className={'cc-score-txt_1_0'} style={{color:getFontColor(active, ccMatch) }}>{this._getRuns(inningses[0]) + '/' + this._getWickets(inningses[0])}</h1>
                <h3 className={'cc-score-txt_1_0'} style={{color:getFontColor(active, ccMatch)}}>{'(' + this._getOvers(inningses[0]) + ')'}</h3>
            </div>)
        }
    }
}

class Score extends Component {

    constructor(props){
        super(props);
        this._getBowlerPerformance=this._getBowlerPerformance.bind(this);
        this._getStrikerPerformance=this._getStrikerPerformance.bind(this);
        this._getNonStrikerPerformance=this._getNonStrikerPerformance.bind(this);
    }

    _getStrikerPerformance(ccMatch){
        const currentStatus = ccMatch.currentStatus;
        const teams = ccMatch.teams;
        var team = _.find(teams,{key : currentStatus.batting_team});
        var player = _.find(team.players,{key : currentStatus.striker});
        if(player){
            var inningsPerformance = _.find(player.currentMatchPerformance, (mp)=>{return mp.innings==currentStatus.innings});
            // this is to handle superover
            if(inningsPerformance)
                return player.name+'*: '+inningsPerformance.batting.runs + '( '+inningsPerformance.batting.balls + ' )';
        }
        return;
    }

    _getNonStrikerPerformance(ccMatch){
        const currentStatus = ccMatch.currentStatus;
        const teams = ccMatch.teams;
        var team = _.find(teams,{key : currentStatus.batting_team});
        var player = _.find(team.players,{key : currentStatus.nonStriker});
        if(player){
            var inningsPerformance = _.find(player.currentMatchPerformance, (mp)=>{return mp.innings==currentStatus.innings});
            // this is to handle superover
            if(inningsPerformance)
                return player.name+': '+inningsPerformance.batting.runs + '( '+inningsPerformance.batting.balls + ' )';
        }
        return;
    }

    _getBowlerPerformance(ccMatch){
        const currentStatus = ccMatch.currentStatus;
        const teams = ccMatch.teams;
        var team = _.find(teams,{key : currentStatus.bowling_team});
        var player = _.find(team.players,{key : currentStatus.bowler});
        if(player){
            var inningsPerformance = _.find(player.currentMatchPerformance, (mp)=>{return mp.innings==currentStatus.innings});
            // this is to handle superover
            if(inningsPerformance)
                return player.name+': '+inningsPerformance.bowling.wickets + '/'+inningsPerformance.bowling.runs;
        }
        return;
    }


    render() {
        const {teamScore, ccMatch} = this.props;
        const active = teamScore.active;
        const strikerPerformance = this._getStrikerPerformance(ccMatch);
        const nStrikerPerformance = this._getNonStrikerPerformance(ccMatch);
        const bowlerPerformance = this._getBowlerPerformance(ccMatch);

        return (
        <div className={'flex-container'} style={{ flex:1, flexDirection:'column', alignItems:'center', justifyContent:'center'}} >
            <InningsScore active={teamScore.active} inningses={teamScore.inningses} ccMatch={ccMatch}/>
            <div>
                {
                    teamScore.active ?
                        <div>
                            {
                                strikerPerformance &&
                                <h3 className={'cc-score-txt_0_8'} style={{color : getFontColor(active, ccMatch) }} >{strikerPerformance}</h3>
                            }
                            {
                                nStrikerPerformance &&
                                <h3 className={'cc-score-txt_0_8'} style={{ color : getFontColor(active, ccMatch)}} >{nStrikerPerformance}</h3>
                            }
                        </div>
                        :
                        <div>
                            {
                                bowlerPerformance &&
                                <h4 className={'cc-score-txt_0_8'} style={{ color : getFontColor(active, ccMatch)}} >{bowlerPerformance}</h4>
                            }
                        </div>
                }
            </div>
        </div>)
    }
}

class SimpleMatchDetails extends Component {

    static propTypes = {
        onPlayPress: PropTypes.func,
        showPlay: PropTypes.bool
    }

    static defaultProps = {
        matchSummary: true,
        onPlayPress: () => {
        },
        showPlay: false
    }

    constructor(props) {
        super(props)
        this.state = {}
        this._getFontSize=this._getFontSize.bind(this);
        this._getButtonText=this._getButtonText.bind(this);
        this._getStyle=this._getStyle.bind(this);
        this._onPlayPress=this._onPlayPress.bind(this);
    }

    _onPlayPress(ccMatch){
        CCAppEventLogger.logAppEvent("PlayViewClicked", {matchKey:ccMatch.key, matchStatus : ccMatch.status});
        this.props.onPlayPress && this.props.onPlayPress();
        this.props.history.push("/match/"+ccMatch.id);
    }

    _getTeamScores(ccMatch) {

        var teamScores = []
        const {currentStatus, inningses, teams} = ccMatch;

        _.forEach(teams, (team) => {
            var teamInningses = inningses[team.key];
            var updatedInnings = [];

            team.active = currentStatus.batting_team == team.key;

            _.forEach(teamInningses, (teamInnings) => {
                if (teamInnings.inningsNo == currentStatus.innings && currentStatus.batting_team == team.key) {
                    teamInnings.active = true;
                }
                updatedInnings.push(teamInnings);
            })

            updatedInnings = _.orderBy(updatedInnings, ['inningsNo'], ['asc']);
            team.inningses = updatedInnings;
            teamScores.push(team);
        });
        return teamScores;
    }

    _getFontSize(text){
        switch (text.length){
            case 2:
            case 3:
                return 16;
                break;
            case 4:
            case 5:
                return 14;
                break;
            default:
                return 14;
        }
    }

    _getButtonText(ccMatch) {
        return ccMatch.status==Constants.matchStatus.COMPLETED ? strings('view_button'):strings('play_button');
    }

    _getStyle(ccMatch) {
        switch (ccMatch.status){
            case Constants.matchStatus.STARTED:
                return {
                    height : '11.5vw',
                    btn_bottom:'-2vw'
                };
            case Constants.matchStatus.NOT_STARTED:
                return {
                    height: '11.5vw',
                    btn_bottom:'-2vw'
                };
            default:
                return {
                    height : '9vw',
                    btn_bottom:'0vw'
                }
        }
    }

    render() {
        const {ccMatch} = this.props;
        let teamScores = this._getTeamScores(ccMatch);

        const sSize = 's';

        let teamA = teamScores[0];
        let teamB = teamScores[1];

        const {showPlay} = this.props;
        return (
            <CCErrorBoundary>
            <div className={'flex-container simple_match_container '+ccMatch.status.toLowerCase()} >
                <div  className={'flex-container simple_match_container2'} >
                    <div className={'simple_match_container3 '}>
                            <div className={'sc-background'}>
                                {
                                    ccMatch.status == Constants.matchStatus.NOT_STARTED ?
                                        <div className={'flex-container padT3_5'} style={{ flexDirection:'column', flex:1,alignItems:'center'}}>
                                            <div className={'sm_counter_margin'}>
                                                <CCCounter style={{flex:1}} date={ccMatch.date}/>
                                            </div>

                                            <div className={'flex-container cc-match-title-div'}>
                                                <h4  className={'cc-match-title-txt'}>{ccMatch.title}</h4>
                                            </div>
                                        </div>
                                        :
                                        <div className={'flex-container padT3_5'} style={{ flex:1, flexDirection: 'column'}}>
                                            <div className={'flex-container'} style={{ flex:1, flexDirection: 'row', justifyContent:'flex-start', alignItems:'center'}}>
                                                <Score teamScore={teamA} ccMatch={ccMatch}></Score>
                                                <Score teamScore={teamB} ccMatch={ccMatch}></Score>
                                            </div>
                                            <div className={'flex-container cc-match-status-div'}>
                                                <h4  className={'cc-match-status-txt'}>{ccMatch.statusShortDescription}</h4>
                                            </div>
                                        </div>
                                }
                                {
                                    showPlay == true &&
                                    <CCLGButton completed={ccMatch.status==Constants.matchStatus.COMPLETED} className={'cc-match-btn'}
                                                title={ this._getButtonText(ccMatch) }
                                                onPress={()=>{this._onPlayPress(ccMatch)}}/>
                                }
                            </div>
                            <div className={'flex-container cc-match-flag-parent'}>
                                <div className={'flex-container'} style={{flex:1, position:'relative', flexDirection:'row'}}>
                                    <div className={'flex-container sc-top-background '+(ccMatch.status==Constants.matchStatus.COMPLETED ? 'sc-top-background-disabled':'' )} >
                                        <div className={'flex-container cc-match-top-flag left'}>
                                            <CCFlag height={"100%"} disabled={ccMatch.status==Constants.matchStatus.COMPLETED} teamKey={teamA.key}/>
                                            <div className={'flex-container cc-match-top-title-div left'}>
                                                <h1 className={"cc-match-top-title-txt left "+ (( ccMatch.status!=Constants.matchStatus.COMPLETED && teamA.active )?'':'inactive')}>{teamA.key.toUpperCase()}</h1>
                                            </div>
                                        </div>
                                        <div ref="test" className={'flex-container cc-match-top-flag right'}  >
                                            <div className={'flex-container cc-match-top-title-div right'}>
                                                <h1 className={"cc-match-top-title-txt right "+ (( ccMatch.status!=Constants.matchStatus.COMPLETED && teamA.active )?'':'inactive')} >{teamB.key.toUpperCase()}</h1>
                                            </div>
                                            <CCFlag  height={"100%"} disabled={ccMatch.status==Constants.matchStatus.COMPLETED}  teamKey={teamB.key}/>
                                        </div>
                                    </div>

                                </div>
                            </div>
                    </div>
                </div>
            </div>
            </CCErrorBoundary>
        )
    }
}


export default withRouter(SimpleMatchDetails);

const styles={

}



// WEBPACK FOOTER //
// ./src/app/components/SimpleMatchDetails/SimpleMatchDetails.js